// Recovered compiled webpack factory 19461. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { w: () => n });
  function n(t) {
    return "string" == typeof t || Array.isArray(t);
  }
}
